import { Theme } from "../../../../components/constants";

export default {
    text: {
        fontSize: "14px",
        color: Theme.TEXT_PRIMARY_BLACK
    },

    tableContainer: {
        padding: "20px 30px"
    },

    headerContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        margin: "20px 0px"
    },

    buttonsContainer: {
        justifyContent: "flex-end",
        display: "flex",
        columnGap: "14px",
        margin: "20px 0px 10px"
    },

    note: {
        color: Theme.DANGER
    }
}